import { MessagingType, DatabaseType, CacheType, StreamingType } from "namirasoft-infra";

export class InfraImages
{
    static environment = "https://static.namirasoft.com/image/namirasoft/infra/entity/environment/base.webp";
    static kubernetes = "https://static.namirasoft.com/image/namirasoft/infra/entity/kubernetes/base.webp";
    static project = "https://static.namirasoft.com/image/namirasoft/infra/entity/project/base.webp";
    static server = "https://static.namirasoft.com/image/namirasoft/infra/entity/server/base.webp";

    static cache: Record<CacheType, string> = {
        [CacheType.Redis]: "https://static.namirasoft.com/image/namirasoft/infra/entity/cache/redis/base.webp"
    };

    static database: Record<DatabaseType, string> = {
        [DatabaseType.Clickhouse]: "https://static.namirasoft.com/image/namirasoft/infra/entity/database/click-house/base.webp",
        [DatabaseType.Elasticsearch]: "https://static.namirasoft.com/image/namirasoft/infra/entity/database/elastic-search/base.webp",
        [DatabaseType.Mongo]: "https://static.namirasoft.com/image/namirasoft/infra/entity/database/mongo/base.webp",
        [DatabaseType.Mysql]: "https://static.namirasoft.com/image/namirasoft/infra/entity/database/mysql/base.webp",
        [DatabaseType.Postgres]: "https://static.namirasoft.com/image/namirasoft/infra/entity/database/postgres/base.webp",
    };

    static messaging: Record<MessagingType, string> = {
        [MessagingType.Rabbitmq]: "https://static.namirasoft.com/image/namirasoft/infra/entity/message-broker/rabbitmq/base.webp",
    };

    static streaming: Record<StreamingType, string> = {
        [StreamingType.Kafka]: "https://static.namirasoft.com/image/namirasoft/infra/entity/message-broker/kafka/base.webp",
    };
}